import styled from 'styled-components'
import { Popover } from 'antd';

interface ContainerProps {
    isBot?: boolean
}
export const Container = styled.div<ContainerProps>`
    width: 100%;
    padding-bottom: 10px;
    display: flex;
    flex-direction: ${props => (props.isBot ? 'row-reverse' : 'row')};
    > .sent {
        background: #f5f2f2;
        max-width: calc(100% - 40%);
        font-weight: 500;
        word-wrap: break-word;
        border-radius: 10px;
        color: #635462;
    }

    > .received {
        border-radius: 10px;
        color: white;
        background-color: #1890FF;
        max-width: calc(100% - 40%);
        font-weight: 500;
        word-wrap: break-word;
    }
}
`

export const Text = styled.div`
    padding: 17px 20px;
    border-radius: 6px;
    font-weight: 300;
    font-size: 14px;
    line-height: 1.4;
    white-space: pre-wrap;
    -webkit-font-smoothing: subpixel-antialiased;
    word-wrap: break-word;
`

export const Time = styled.div`
    position: relative;
    width: 70px;
    > p {
        width: 100%;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    > .right {
        text-align: right;
    }
`

export const ContainerPopOver = styled.div`
    width: 400px;
    max-height: 400px;
    overflow: hidden;
    overflow-y: scroll;
}
`

export const ToolBoxArea = styled.div`
    margin-left: 10px;
    min-width: 50px;
    position: relative;
    > * {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
}
`
export const IntentPopOver = styled(Popover)`
 > .intentPopOver {
     background: color
 }
}
`


